<template>
	<!-- mobile vendor menu -->
	<div class="navbar-nav mt-3">
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a class="nav-item nav-link" :href="'/salon/'+user.salon.name"><span class="fas fa-home fa-fw"></span>Početna</a>
		</li>
		<!--
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('nadzorna')" class="nav-item nav-link" href="/vendor#nadzorna"><span class="fas fa-tachometer-alt fa-fw"></span>Nadzorna ploča</a>
		</li>
		-->
		<!--
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('terminiNav')" class="nav-item nav-link" href="/vendor#terminiNav"><span class="far fa-calendar-check fa-fw"></span>Rezervacije</a>
		</li>
		-->
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('raspored')" class="nav-item nav-link" href="/vendor#raspored"><span class="far fa-calendar-alt fa-fw"></span>Raspored</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('komentari')" class="nav-item nav-link" href="/vendor#komentari"><span class="far fa-comments fa-fw"></span>Komentari</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('usluge')" class="nav-item nav-link" href="/vendor#usluge"><span class="fas fa-hand-holding-usd fa-fw"></span>Usluge</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('galerija')" class="nav-item nav-link" href="/vendor#galerija"><span class="far fa-images fa-fw"></span>Galerija</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('salon')" class="nav-item nav-link" href="/vendor#salon"><span class="fas fa-store-alt fa-fw"></span>Salon</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('zaposlenici')" class="nav-item nav-link" href="/vendor#zaposlenici"><span class="fas fa-user-friends fa-fw"></span>Djelatnici</a>
		</li>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="openPage('postavke')" class="nav-item nav-link" href="/vendor#postavke"><span class="fas fa-cog fa-fw"></span>Postavke profila</a>
		</li>
		<div class="dropdown-divider"></div>
		<li data-toggle="collapse" data-target=".navbar-collapse.show">
			<a @click="logoutNow($event)" class="nav-item nav-link" href="/vendor#">
				<span class="fas fa-sign-out-alt fa-fw"></span>Odjavi se</a>
		</li>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		computed: {
			...mapState({
				user: (state) => state.user
			})
		},
		methods: {
			logoutNow(e) {
				e.preventDefault();
				this.$store.commit('logout');
				window.location.href = '/';
			},
			openPage(page) {
				setTimeout(() => {
					document.getElementById(page).click();
				}, 500);
			}
		},
		mounted() {}
	}

</script>
<style scoped>
	.nav-item {
		color: black !important;
	}

	.nav-item span {
		margin-right: 10px;
	}

	#login-container a {
		color: black !important;
	}

</style>
